import type { IComponentController, ITranscludeFunction } from "angular";
import { isDefined } from "angular";

import type { IProfileService } from "App/Modules/Auth";
import type { IResponseWithLoading } from "App/Modules/Models";
import { Permission } from "App/Modules/Models";
import type { IModalService } from "App/Modules/Services/FormContainer/Modal/IModalService";

export class ListGroupItemComponentController implements IComponentController {
    public static $inject = ["$scope", "$element", "mmProfileService", "$transclude", "$location", "mmModalService"];

    public icon: string;

    public iconTitle: string;

    public iconAppend: string;

    public iconClass: string;

    public numLinesClass: string;

    public itemHeading: string;

    public itemText: string;

    public itemSecondaryText: string;

    public itemClass: string;

    public isActive: boolean;

    public isExpandable: boolean;

    public isExpanded: boolean;

    public primaryClick: () => void;

    public primaryHref: string;

    public secondaryIcon: string;

    public secondaryText: string;

    public secondaryClick: () => void;

    public secondaryActionResponse: IResponseWithLoading<any>;

    public showItemAsLink: boolean;

    public showSecondaryButton: boolean;

    public actionsPermission: string;

    public hasActionsPermission: boolean;

    public secondaryActionsPermission: string;

    public hasSecondaryActionsPermission: boolean;

    public showAdjacentText: boolean;

    constructor(
        private readonly $scope: ng.IScope,
        private readonly $element: ng.IAugmentedJQuery,
        private readonly profileService: IProfileService,
        private readonly $transclude: ITranscludeFunction,
        private readonly $location: ng.ILocationService,
        private readonly modalService: IModalService,
    ) {}

    public $onInit() {
        if (isDefined(this.actionsPermission)) {
            const permissionEnum = Permission[this.actionsPermission as keyof typeof Permission];
            if (!permissionEnum) {
                throw new TypeError(`ListGroupItemComponent: Unknown permission :${this.actionsPermission} `);
            }
            this.hasActionsPermission = this.profileService.hasPermission(permissionEnum);
        } else {
            this.hasActionsPermission = true;
        }

        if (isDefined(this.secondaryActionsPermission)) {
            const permissionEnum = Permission[this.secondaryActionsPermission as keyof typeof Permission];
            if (!permissionEnum) {
                throw new TypeError(`ListGroupItemComponent: Unknown permission :${this.secondaryActionsPermission} `);
            }
            this.hasSecondaryActionsPermission = this.profileService.hasPermission(permissionEnum);
        } else {
            this.hasSecondaryActionsPermission = this.hasActionsPermission;
        }

        this.showItemAsLink = isDefined(this.primaryHref) || isDefined(this.primaryClick);

        this.showSecondaryButton = isDefined(this.secondaryIcon) && this.hasSecondaryActionsPermission;
        this.showAdjacentText = this.$transclude.isSlotFilled("adjacentText");

        this.itemClass = this.itemClass || "";
        this.iconClass = this.iconClass || "";

        if (isDefined(this.isExpandable) && this.isExpandable) {
            this.iconAppend = "chevron-down";
            this.showItemAsLink = true;
            this.showSecondaryButton = false;
        }

        this.numLinesClass = "list-group-item-one-line";

        if (
            (isDefined(this.itemText) || this.$transclude.isSlotFilled("text")) &&
            (isDefined(this.itemSecondaryText) || this.$transclude.isSlotFilled("secondaryText"))
        ) {
            this.numLinesClass = "list-group-item-three-lines";
        } else if (
            isDefined(this.itemText) ||
            this.$transclude.isSlotFilled("text") ||
            isDefined(this.itemSecondaryText) ||
            this.$transclude.isSlotFilled("secondaryText")
        ) {
            this.numLinesClass = "list-group-item-two-lines";
        }
    }

    public primaryButtonClick($event: ng.IAngularEvent) {
        if (this.isExpandable) {
            this.isExpanded = !this.isExpanded;
            $event.preventDefault();
        } else if (this.primaryClick) {
            this.primaryClick();
        }

        if (!this.primaryHref) {
            $event.preventDefault();
        }

        if (this.primaryHref && this.primaryHref.replace("#!", "") === this.$location.url()) {
            this.modalService.closeAll();
        }
    }

    public secondaryButtonClick() {
        if (this.secondaryClick) {
            this.secondaryClick();
        }
    }
}
